<template>
    <div>
        <lightbox-awareness
            class="mt-5 mx-8"
            wrap_early
            @visibility-changed="onLightboxPromoVisibilityChanged"
        />

        <div class="container">
            <div
                class="img_container"
                :class="is_lightbox_promo_visible && 'has_promo'"
            >
                <img
                    src="@/assets/redchirp-logo-square-center.png"
                    alt="RedChirp logo"
                    class="img"
                />
                let's connect!
            </div>
        </div>
    </div>
</template>

<script>
import LightboxAwareness from '@/components/lightbox/lightbox-awareness.vue';

export default {
    components: {
        LightboxAwareness
    },

    data() {
        return {
            is_lightbox_promo_visible: true
        }
    },

    methods: {
        onLightboxPromoVisibilityChanged(is_visible) {
            this.is_lightbox_promo_visible = is_visible
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;

    display: flex;
    justify-content: center;
    align-items: center;
    z-index: -1;
    text-align: center
}

.img_container {
    display: inline-block;
    width: 35%;
    margin: 0 auto;

    font-family: Roboto, "Helvetica Neue", sans-serif, NotoColorEmoji, "apple color emoji", "windows emoji", "windows symbol";
    font-size: 18px;
    font-weight: 700;
    color: #5d647c;

    @media all and (max-height: 1100px) {
        &.has_promo {
            margin-top: 16rem;
        }
    }
}

.img {
    max-width: 100%;
    max-height: 100%;
    opacity: 0.25;
}
</style>